// Adventurer selection — shown once after first registration

import { ADVENTURERS } from '../components/adventurer/AdventurerStamp';
import AdventurerStamp from '../components/adventurer/AdventurerStamp';
import type { AdventurerId } from '../components/adventurer/AdventurerStamp';
import { useState } from 'react';

interface Props {
  childName: string;
  onSelect: (id: AdventurerId) => void;
}

export default function AdventurerSelectScreen({ childName, onSelect }: Props) {
  const [hovered, setHovered] = useState<AdventurerId | null>(null);

  const adventurers = Object.values(ADVENTURERS);

  return (
    <div style={{
      display: 'flex', height: '100dvh',
      alignItems: 'center', justifyContent: 'center',
      background: 'var(--parchment)',
      fontFamily: 'var(--sans)',
    }}>
      <div style={{ width: '100%', maxWidth: 640, padding: '0 24px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 40 }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            fontFamily: 'var(--mono)',
            fontSize: 10, letterSpacing: '0.25em',
            color: 'var(--ink-muted)', textTransform: 'uppercase', marginBottom: 10,
          }}>Willkommen, {childName}!</div>
          <div style={{
            fontFamily: 'var(--display)',
            fontSize: 40, fontWeight: 600,
            color: 'var(--ink)', letterSpacing: '-0.02em', lineHeight: 1.1,
          }}>Wähle deinen Begleiter</div>
          <div style={{
            fontFamily: 'var(--serif)',
            fontSize: 17, fontStyle: 'italic',
            color: 'var(--ink-muted)', marginTop: 10, lineHeight: 1.5,
          }}>
            Wer begleitet dich durch dein Lernabenteuer?
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 20, width: '100%' }}>
          {adventurers.map(adv => {
            const isHov = hovered === adv.id;
            return (
              <button
                key={adv.id}
                onClick={() => onSelect(adv.id)}
                onMouseEnter={() => setHovered(adv.id)}
                onMouseLeave={() => setHovered(null)}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16,
                  padding: '28px 16px 24px',
                  background: isHov ? 'var(--amber-soft)' : 'var(--card)',
                  border: `2px solid ${isHov ? 'var(--amber)' : 'rgba(60,50,40,0.12)'}`,
                  borderRadius: 6,
                  cursor: 'pointer',
                  transition: 'all 0.18s',
                  transform: isHov ? 'translateY(-4px)' : 'none',
                  boxShadow: isHov ? '0 8px 24px rgba(201,106,47,0.18)' : '0 2px 6px rgba(0,0,0,0.04)',
                }}
              >
                <AdventurerStamp id={adv.id} size={80} active={true} />

                <div style={{ textAlign: 'center' }}>
                  <div style={{
                    fontFamily: 'var(--display)',
                    fontSize: 22, fontWeight: 600,
                    color: 'var(--ink)', marginBottom: 4,
                  }}>{adv.name}</div>
                  <div style={{
                    fontFamily: 'var(--mono)',
                    fontSize: 9, letterSpacing: '0.18em',
                    color: 'var(--ink-muted)', textTransform: 'uppercase', marginBottom: 10,
                  }}>{adv.species}</div>
                  <div style={{
                    fontFamily: 'var(--serif)',
                    fontSize: 13, fontStyle: 'italic',
                    color: 'var(--ink-soft)', lineHeight: 1.4,
                  }}>{adv.tagline}</div>
                </div>

                <div style={{
                  fontFamily: 'var(--sans)',
                  fontSize: 12,
                  color: adv.color,
                  fontStyle: 'italic',
                  lineHeight: 1.3,
                  textAlign: 'center',
                  borderTop: '1px dashed rgba(60,50,40,0.12)',
                  paddingTop: 12,
                  width: '100%',
                }}>
                  „{adv.voice}"
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
